var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{class:{ 'sr-only': _vm.hide_label },attrs:{"for":'input-' + _vm.id}},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('b-form-select',{attrs:{"id":'input-' + _vm.id,"options":_vm.options},on:{"change":_vm.emitToParent},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08301ed3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/InputSelect/InputSelect.vue
// module id = null
// module chunks = 